import { Link } from 'gatsby';

import './masthead.css';

import React from 'react';
import PropTypes from 'prop-types';

import orange_matrix from '../images/background/orange-matrix.webp';

const Masthead = ({
  children,
  title,
  subHeading,
  subTitle,
  subImages,
  backgroundImage,
  separator,
  dim,
  readMore,
  fixed,
  darkMode,
}) => {
  let subImagesList = null;

  if (subImages) {
    subImagesList = subImages.map((item) => <img src={item} alt="" className="header-image" />);
  }

  let mastheadClass = 'masthead-container';

  if (fixed) mastheadClass += ' masthead-container-fixed';

  if (darkMode) mastheadClass = 'masthead-container-dark ' + mastheadClass;

  let titleSize = '4rem';

  const titleWords = title.split(' ').length;

  if (titleWords >= 7) {
    titleSize = '3.5rem';
  } else if (titleWords > 10) {
    titleSize = '3rem';
  }

  const titleStyle = { fontSize: titleSize };

  return (
    <div
      className={mastheadClass}
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, ${dim}) 0%, rgba(0, 0, 0, ${dim}) 0%), url("${backgroundImage}")`,
      }}
    >
      <div className="content">
        <div className="text">
          <div className="title" style={titleStyle}>
            {title}
          </div>
          {subHeading ? <div className="subHeading">{subHeading}</div> : ''}
          <div className="description">{children ? children : <p>{subTitle}</p>}</div>
        </div>
        {subImagesList ? <div className="images">{subImagesList}</div> : ''}
      </div>
      <div
        className="separator-container"
        style={{
          backgroundColor: separator ? null : 'white',
        }}
      >
        {separator ? <img alt="" className="separator" src={separator} /> : ''}
      </div>

      {readMore ? (
        <div className="read-more-container">
          <p>
            <Link to={readMore}>Read more</Link>
          </p>{' '}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

Masthead.propTypes = {
  title: PropTypes.string,
  subHeading: PropTypes.string,
  subTitle: PropTypes.string,
  subImages: PropTypes.array,
  backgroundImageIndex: PropTypes.string,
  separator: PropTypes.string,
  dim: PropTypes.number,
  readMore: PropTypes.string,
  fixed: PropTypes.bool,
  darkMode: PropTypes.bool,
};

Masthead.defaultProps = {
  title: 'We Are Intrepid',
  subHeading: '',
  subTitle:
    'We help businesses overcome technology related challenges, and our proficient team is ' +
    'committed to ensuring that no business is hindered by technology, irrespective of their expertise, ' +
    'experience, or background.',
  subImages: null,
  backgroundImage: orange_matrix,
  separator: '',
  dim: 0.4,
  fixed: false,
  darkMode: false,
};

export default Masthead;
